<script setup lang="ts">
import { Footer } from "~/components/footer"
import { NavBottombar, NavTopbar } from "~/components/nav"
import { useBottomBarVisibility } from "~/composables/bottomBar"
import { useLocation } from "~/composables/locations"
import { cn } from "~/lib/utils"
const { showBottomBar } = useBottomBarVisibility()
const { location } = useLocation()

</script>

<template>
    <div class="flex min-h-svh w-full flex-col">
        <NavTopbar />
        <main id="main-content">
            <slot />
        </main>
        <Footer />
        <Transition
            enter-active-class="transition-all duration-300 ease-out"
            leave-active-class="transition-all duration-300 ease-in"
            enter-from-class="opacity-0 translate-y-full"
            enter-to-class="opacity-100 translate-y-0"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-full"
        >
            <NavBottombar
                :class="cn(
                    'md:hidden transition-all duration-300 ease-out will-change-transform',
                    showBottomBar && !location?.closed
                        ? 'translate-y-0 opacity-100 pointer-events-auto'
                        : 'translate-y-full opacity-0 pointer-events-none'
                )"
            />
        </Transition>
    </div>
</template>
